var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-card",
      style: { minHeight: 80 + "vh", minWidth: 50 + "vw" },
    },
    [
      _vm._m(0),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _c(
            "form",
            {
              attrs: { id: "qtyForm" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.submitQtyForm.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "b-field",
                { attrs: { label: _vm.$t("pages.loads.receipt_date") } },
                [
                  _c("b-datetimepicker", {
                    attrs: {
                      placeholder: "Click to select...",
                      icon: "calendar",
                      "max-datetime": _vm.maxDatetime,
                      "min-datetime": _vm.minDatetime,
                      "horizontal-time-picker": "",
                      required: "",
                      disabled: _vm.disbaleCalendar,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "left",
                        fn: function () {
                          return [
                            _c("b-button", {
                              attrs: {
                                label: "Now",
                                type: "is-primary",
                                "icon-left": "clock",
                              },
                              on: {
                                click: function ($event) {
                                  _vm.matForm.date = new Date()
                                },
                              },
                            }),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                    model: {
                      value: _vm.matForm.date,
                      callback: function ($$v) {
                        _vm.$set(_vm.matForm, "date", $$v)
                      },
                      expression: "matForm.date",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { label: "Material" } },
                [
                  _c(
                    "b-select",
                    {
                      attrs: { placeholder: "select a material" },
                      model: {
                        value: _vm.qtyForm.material,
                        callback: function ($$v) {
                          _vm.$set(_vm.qtyForm, "material", $$v)
                        },
                        expression: "qtyForm.material",
                      },
                    },
                    _vm._l(_vm.availableMaterials, function (material) {
                      return _c(
                        "option",
                        {
                          key: material.ref,
                          domProps: { value: material.ref },
                        },
                        [_vm._v(" " + _vm._s(material.ref) + " ")]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c("b-field", { attrs: { label: "Quantity" } }, [
                _c(
                  "div",
                  { staticClass: "is-flex is-align-content-center" },
                  [
                    _c("b-input", {
                      attrs: { type: "number", min: "0" },
                      model: {
                        value: _vm.qtyForm.qty,
                        callback: function ($$v) {
                          _vm.$set(_vm.qtyForm, "qty", $$v)
                        },
                        expression: "qtyForm.qty",
                      },
                    }),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-1",
                        attrs: {
                          type: "is-info",
                          disabled: !_vm.qtyForm.material,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.calMaxQty(_vm.qtyForm.material)
                          },
                        },
                      },
                      [_vm._v(" max ")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _vm.showMatForm
            ? _c(
                "b-table",
                { staticClass: "mt-5", attrs: { data: _vm.matForm.data } },
                [
                  _c(
                    "b-table-column",
                    { attrs: { field: "dateField", label: "Date time" } },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm
                              .$dayjs(_vm.matForm.date)
                              .format("YYYY-MM-DD HH:mm:ss")
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c("b-table-column", {
                    attrs: { field: "material", label: "Material" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _vm._v(" " + _vm._s(props.row.material) + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3026577782
                    ),
                  }),
                  _c("b-table-column", {
                    attrs: { field: "qty", label: "Quantity" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [_vm._v(" " + _vm._s(props.row.qty) + " ")]
                          },
                        },
                      ],
                      null,
                      false,
                      2040484353
                    ),
                  }),
                  _c("b-table-column", {
                    attrs: { label: "Action" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("b-button", {
                                attrs: { "icon-left": "trash-can" },
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteRow(props.row.material)
                                  },
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      44387243
                    ),
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c(
            "b-field",
            { staticClass: "ml-auto buttons" },
            [
              _c(
                "b-button",
                {
                  attrs: { disabled: _vm.disableAddButton },
                  on: { click: _vm.add },
                },
                [_vm._v(" Add ")]
              ),
              _c(
                "b-button",
                {
                  attrs: {
                    type: "is-primary",
                    "native-type": "submit",
                    form: "qtyForm",
                    loading: _vm.isSubmitting,
                    disabled: _vm.disabledSubmit,
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("global.submit")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "modal-card-head" }, [
      _c("p", { staticClass: "modal-card-title" }, [
        _vm._v(" Attach material by quantity "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }